import axiosInstance from '../../utils/axiosInstanse';
import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';
import Spiner from '../Spiner/Spiner';
import host from "../../host";
import Card from "./Card";
import './archive.css';

function Archive() {
  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');

  const filteredData = useMemo(() => {
    if (search === '' || search === undefined) return notes;
    return notes.filter(item => {
      const itemValues = Object.values(item);
      return itemValues.some(value => String(value).includes(search));
    });
  }, [notes, search]);

  const normalData = (date) => {
    let [day, month, year] = date.split('.');
    if (day.length === 1) { day = '0' + day; }
    if (month.length === 1) { month = '0' + month; }
    return `${day}.${month}.${year}`;
  };

  useEffect(() => {
    axiosInstance.get(`${host}api/notes/`)
      .then(response => {
        const new_data = response.data.map(item => {
          return {
            ...item,
            date: normalData(item.date)
          };
        });
        setNotes(new_data);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="arch-container">
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.12 }}
      >

        {isLoading ? (
          <Spiner />
        ) : (
          <>
            <div className="arch-search-wrap">
              <label className="arch-label" htmlFor="archSearch">
                Поиск
              </label>
              <input
                id="archSearch"
                type="text"
                className="arch-input"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Введите текст для поиска..."
              />
              <div className="arch-hint">Введите критерии поиска</div>
            </div>

            {notes.length > 0 ? (
              filteredData.map((note) => (
                <Card key={note.id} note={note} />
              ))
            ) : (
              <div className="arch-empty">
                У вас еще нет ни одной записки
              </div>
            )}
          </>
        )}
      </motion.div>
    </div>
  );
}

export default Archive;